import ApiService from './ApiService'

export async function apiGetTree(data) {
    return ApiService.fetchData({
        url: '/tree/get',
        method: 'post',
        data,
    })
}